import profileService from "../services/profile.service";

const initialState = { profile: null, permisos: null };

export const profile = {
  namespaced: true,
  state: initialState,
  actions: {
    async getProfile({ commit }) {
      const response = await profileService.getProfile();
      commit("SET_PROFILE", response);
    },

    async uploadPic(_, object) {
      return await profileService.uploadPic(object);
    },

    async updateProfile({ commit }, profile) {
      const response = await profileService.updateProfile(profile);
      commit("SET_PROFILE", response);
    },

    async getPermisos({ commit }) {
      const response = await profileService.getPermisos();
      commit("SET_PERMISOS", response);
      return response;
    },
  },

  mutations: {
    RESET_PROFILE(state) {
      state.profile = null;
      state.permisos = null;
    },
    SET_PROFILE(state, profile) {
      state.profile = profile;
    },
    SET_PERMISOS(state, permisos) { 
      state.permisos = permisos;
    },
  },

  getters: {
    profile(state) {
      return state.profile;
    },
    permisos(state) {
      return state.permisos;
    }
  },
};
